module.exports = __webpack_public_path__ + "static/media/seinfeld_squared.0605a218.png";